import {SpinnerService} from '../../services/spinner.service';
import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {finalize, Observable} from 'rxjs';
import {inject} from '@angular/core';

export function getPath(req: HttpRequest<unknown>): string {
    return `${req.method}&${req.urlWithParams}&${Date.now()}}`;
}

export const includeSpinnerInterceptor: (req: HttpRequest<unknown>, next: HttpHandlerFn) => Observable<HttpEvent<unknown>>
    = (req, next) => {
    const path = getPath(req);
    const _spinnerService: SpinnerService = inject(SpinnerService);
    _spinnerService.activate(path);
    return next(req).pipe(finalize(() => _spinnerService.deactivate(path)));
};